import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Form, Modal, Table } from "react-bootstrap";
import Select from "react-select";
import { Prompt } from "react-router";
import moment from 'moment';
import Checkbox from 'src/components/common/checkbox';
import SearchInput from "src/components/common/SearchInput";
import EditBillingGroup from "./EditBillingGroup";
import { shouldAllowAccess } from "../../utilities/helper";
import InvoiceEmailPreview from "./email_preview/InvoiceEmailPreview";
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import { BillingGroupType, InvoiceType, ProfitCenterType, DateSelect, BillingGroupNameType, InvoicePaymentType, AttachmentRecordType, EditableInvoiceType } from "./types";
import { getWeekEndingsFromWeekData, handleInvoiceGroupOrProfitCenterChange, handleInvoiceOrProfitCenterCheck, handleSearch, handleWeekEndChange, debounce, checkforNullAndSort } from "./InvoiceLogic";
import InvoiceSearch from "./InvoiceSearch";
import MsalAuth from '../../utilities/msalAuth';
//import InvoiceUploader from "./uploader/InvoiceUploader";
import { connect } from "react-redux";
import DocViewer from "./InvoiceViewer/InvoiceDocViewer";
import dayjs from "dayjs";
import './invoice.css';

const Invoice = (props:any) => {
    const [resendModal, setResendModal] = useState(false)
    const [inputFocus, setInputFocus] = useState("")
    const [sortDir, setSortDir] = useState<number>(1)
    const [sortCol, setSortCol] = useState<string>("InvoiceNumber")
    const [iPData, setIPData] = useState({ invoiceGroups: [], profitCenters: [] as any });
    //r-18-lint-cm
    //eslint-disable-next-line
    const [showPastDueAlert, setShowPastDueAlert] = useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [alertText, setAlertText] = useState("");
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [showEditBillingGroup, setShowEditBillingGroup] = useState(false);
    const [currentInvoice, setCurrentInvoice] = useState({} as InvoiceType);
    const [currentBillingGroup, setCurrentBillingGroup] = useState({} as BillingGroupType);
    const [showEmailPreview, setShowEmailPreview] = useState(false);
    const [radioSelect, setRadioSelect] = useState("invoiceGroup");
    const [selectedInvoiceGOrProfitC, setSelectedInvoiceGOrProfitC] = useState({ label: "none", value: "none" });
    const [invoices, setInvoices] = useState([] as EditableInvoiceType[]);
    const [weekEndingArray, setWeekEndingArray] = useState([] as string[]);
    const [weekEndSelection, setWeekEndSelection] = useState("" as string);
    const [billingGroups, setBillingGroups] = useState([] as BillingGroupType[]);
    const [activeBillingGroups, setActiveBillingGroups] = useState([] as BillingGroupType[]);
    const [billingGroupsLoaded, setBillingGroupsLoaded] = useState(false);
    const [activeBillingGroupsLoaded, setActiveBillingGroupsLoaded] = useState(false);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [savingIndex, setSavingIndex] = useState<number[]>([])
    const [dirtyCurrentInvoice, setDirtyCurrentInvoice] = useState(false)
    //r-18-lint-cm
    //eslint-disable-next-line
    const [invoicesFromSearch, setInvoicesFromSearch] = useState([] as EditableInvoiceType[]);
    const [contactDetailsOnly, setContactDetailsOnly] = useState(false);
    const [saving, setSaving] = useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [iPItemsToEdit, setIPItemsToEdit] = useState([] as InvoiceType[]);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [invoicePaymentsFromSearch, setInvoicePaymentsFromSearch] = useState([] as InvoicePaymentType[]);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [userSettings, setUserSettings] = useState(MsalAuth.UserSettings() || {});
    //r-18-lint-cm
    //eslint-disable-next-line
    const [dateWillConvert, setDateWillConvert] = useState(false);
    const [datesInProgress, setDatesInProgress] = useState([] as number[])
    // ************************ File Uploader state  *****************************
    const [showUploader, setShowUploader] = useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [relativePathString, setRelativePathString] = useState("");
    //r-18-lint-cm
    //eslint-disable-next-line
    const [fileExtension, setFileExtension] = useState("");
    const [attachmentRecords, setAttachmentRecords] = useState([{}] as AttachmentRecordType[]);
    //************************************ End of File uploader State stuff */ 
    const [showInvoice, setShowInvoice] = useState(false);
    const [currIndex, setCurrIndex] = useState(0)
    //TODO: REMOVE IF NOT NEEDED previous item for making sure I don't display duplicate invoices due to the attachmentIDs adding them in the get
    // let previousItem: InvoiceType;
    let numberOfRecords = invoices?.length;


    let searchItem = "";
    const config = AxiosConfig.configValue("min");
    // let hasInvoice = false;  // I'm not using this anymore.  May need to remove later.
    let weekEnd: DateSelect[] = [{ label: '', value: 0 }]

    // **************************** Getting Week Ending dates *********************************************** 
    useEffect(() => {
        Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getweeks`, config)
            .then((res) => {
                //console.log(`%c Weeks Data`, "color: lightGreen; font-size: 18px; font-weight: bold", res.data);
                setWeekEndingArray(getWeekEndingsFromWeekData(res.data));
            }).catch(err => {

            })
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [])

    // **************************** Initial data for dropdown selects ****************************************
    useEffect(() => {
        const invoiceGroupRequest = Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getinvoicegroups`, config);
        const profitCenterRequest = Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getprofitcenters`, config);
        // let time = performance.now();
        Axios.all([invoiceGroupRequest, profitCenterRequest])
            .then((responses) => {
                //console.log(`${(performance.now() - time) / 1000} seconds for Invoice Group and Profit Center initial GET`);
                let invoiceGroupTemp = responses[0].data;
                let profitCenterTemp = responses[1].data;
                const newIPData = { invoiceGroups: invoiceGroupTemp, profitCenters: profitCenterTemp };
                setIPData(newIPData);
            })
            .catch((err) => {
                //console.log(`%c Error'd on test: ${err}`, "color: red; font-size:14px; font-weight: bold");
            })
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [])

    //************************** Billing Groups is pretty slow get now that I asked to get inactive and actives.  May need to get two separate endpoints on this */
    useEffect(() => {
        getActiveBillingGroups();
        Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getbillinggroups/true`, config)
        .then((res) => {
            setBillingGroups([...res.data])
            setBillingGroupsLoaded(true);
        })
        .catch((err) => {
            //console.log(`%c Error in getting billing groups: ${err}`, "color: red; font-size:14px; font-weight: bold");
        })
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [])

    //TODO: This one is a little slow for some reason, may need to see if there is a way around for updating the billing group after edit
    const getActiveBillingGroups = () => {
        // let time = performance.now();
        const billingGroupRequest = `${process.env.REACT_APP_API_URL}/api/ip/getbillinggroups/false`
        Axios.get(billingGroupRequest, config)
            .then((res) => {
                //console.log(`${(performance.now() - time) / 1000} seconds for  Getting Billing Groups Names for invoice listing`);)
                setActiveBillingGroups([...res.data]);
            })
            .catch((err) => {
                //console.log(`%c Error in getting billing groups: ${err}`, "color: red; font-size:14px; font-weight: bold");
            })
            .finally(() => setActiveBillingGroupsLoaded(true))
    }

    // **************************** Section for items that will be removed after full functionality

    const handleShowPastDueSummary = () => {//wtf?

    }

    // **************************** Right click context menu and invoice change on hover ***************************************
    const handleContextMenu = (event: { preventDefault: () => void; pageX: any; pageY: any; }, Index: number, billingGroupId: number, index:number) => {
        event.preventDefault();
        setAnchorPoint({ x: event.pageX-270, y: event.pageY-50});
        setShowContextMenu(!showContextMenu);
        setHoverInvoice(Index, billingGroupId, index)
    }

    const setHoverInvoice = (Index: number, billingGroupId: number, index:number) => {
        try {
            setHoverBillingGroup(billingGroupId)
            if (invoices.some((e: EditableInvoiceType) => e.Index === Index)) {
                let currInvoice: EditableInvoiceType = invoices.find((invoice: EditableInvoiceType) => invoice.Index === Index)!;
                setCurrentInvoice(currInvoice);
                var dirty = (currInvoice.Dirty || !currInvoice.FromIP)
                setDirtyCurrentInvoice(dirty)
                setCurrIndex(index)
            }
        } catch (err) {
            //console.log(`%c Error getting invoice from InvoiceProgressID: ${err}`, "color: red; font-size:14px; font-weight: bold")
        }
    }

    const setHoverBillingGroup = (billingGroupId: number) => {
        try {
            let bGroup: BillingGroupType = activeBillingGroups.find((group: BillingGroupType) => group.BillingGroupID === billingGroupId)!;
            setCurrentBillingGroup(bGroup);
        } catch (err) {
            //console.log(`%c Error getting Billing group from ID: ${err}`, "color: red; font-size:14px; font-weight: bold")
        }
    }

    // ****************************  Selection of Invoice Group and or Profit Center and Week **************************************
    useEffect(() => {
        getInvoicesByIGorPC(-99);
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [selectedInvoiceGOrProfitC, weekEndSelection])

    const getInvoicesByIGorPC = (id: number) => {
        let today = Date.now();
        let todayFormatted = dayjs(today).format('YYYY-MM-DD');
        //console.log("Formatted Date", todayFormatted);
        let endWeekDate = (weekEndSelection).replaceAll("/", "-") || todayFormatted.toString();
        //console.log(new Date(todayFormatted))
        // endWeekDate = endWeekDate.replaceAll("/", "-");
        let invoiceGet = `${process.env.REACT_APP_API_URL}/api/ip/getinvoiceprogressbyweekendingandinvoicegroup/${endWeekDate}/${selectedInvoiceGOrProfitC.value}`
        if (selectedInvoiceGOrProfitC.value !== "none") {
            if (radioSelect === 'profitCenter') {
                invoiceGet = `${process.env.REACT_APP_API_URL}/api/ip/getinvoiceprogressbyweekendingandprofitcenter/${endWeekDate}/${selectedInvoiceGOrProfitC.value}`
            }
            else if (radioSelect === 'invoiceGroup') {
                invoiceGet = `${process.env.REACT_APP_API_URL}/api/ip/getinvoiceprogressbyweekendingandinvoicegroup/${endWeekDate}/${selectedInvoiceGOrProfitC.value}`
            }
        }
        getInvoiceProgressFromApi(invoiceGet, id)
    }

    const getInvoiceProgressFromApi = (apiGetURL: string, id: number) => {
        // let time = performance.now();
        Axios.get(apiGetURL, AxiosConfig.configValue())
            .then((res) => {
                //console.log(apiGetURL)
                //console.log(`${(performance.now() - time) / 1000} seconds for  Getting invoices with IG or PC and week end date`);
                //If a user hovered on an item quickly after changing it would stay seleced on an old invoice
                var copy = invoices
                setCurrentInvoice({} as InvoiceType);
                var data = res.data.sort((a:EditableInvoiceType,b:EditableInvoiceType) =>{
                    var num = a.InvoiceNumber.localeCompare(b.InvoiceNumber)
                    var profit = a.ProfitCenterDesc.localeCompare(b.ProfitCenterDesc)
                    if(num!==0){
                        return num
                    }
                    else{
                        return profit
                    }
                })
                data  = makeEditableIPs(data)
                var databaseInvoices = data.map((invoice: EditableInvoiceType) => {
                    var copyInvoice = copy.find(x => x.InvoiceProgressID === invoice.InvoiceProgressID && x.InvoiceProgressID!==id)
                    if(copyInvoice){
                        return copyInvoice
                    }
                    else{
                        return invoice
                    }
                });
                setInvoices([...databaseInvoices])
            })
            .catch((err) => {
                //console.log(`%c Error getting by week invoices: ${err}`, "color: red; font-size:14px; font-weight: bold");
            })
    }
    // //console.log("INVOICES ", invoices)'

    const makeEditableIPs = (iPItems: InvoiceType[]) => {
        setInvoices([]) //IP data in the Date-Sent fields were not repopulating correctly after update.  this resetst the data on each pull.
        let editableIPItems: EditableInvoiceType[] = []
        for (let i = 0; i < iPItems.length; i++) {
            if(iPItems[i].BillableTickets == null && iPItems[i].InvoiceAmount == null && !iPItems[i].FromIP){
                editableIPItems.push({ ...iPItems[i], Dirty: false, Index: i, FromIP: true })
            }
            else{
                editableIPItems.push({ ...iPItems[i], Dirty: false, Index: i })
            }
        }
        //console.log(editableIPItems);
        return editableIPItems;
    }

    const makeItemEditable = (invoiceItem: InvoiceType, invoiceItemsIndex: number) => {
        let newlyEditableItem: EditableInvoiceType = {
            ...invoiceItem,
            Dirty: false,
            Index: invoiceItemsIndex
        }
        return newlyEditableItem
    }

    // ****************************  Search ::: Larger functions in InvoiceLogic.ts  *********************************************

    const debouncedSearch = debounce(function () {
        handleSearch(searchItem, setInvoices, makeEditableIPs);
        //console.log("Searching", searchItem, invoicesFromSearch);
    }, 1000, onclick);

    const handleSearchChange = (e: any) => {
        e.preventDefault();
        searchItem = e.target.value;
        debouncedSearch();
    }

    //?? potentially to be used with past due summary
    const selectInvoiceFromSearch = () => {
        setInvoices([...makeEditableIPs(invoicesFromSearch)]);
    }

    const handleShowContactClick = () => {
        setContactDetailsOnly(true);
        setShowEditBillingGroup(true);
    }

    // ****************************  Mapping for IG PC and WeekEnding *************************************
    // null values can creep in these from the db.  Filtering those out and separated sort function out to InvoiceLogic.tsx
    let mappedInvoiceGroup = iPData?.invoiceGroups.map((ig: string) => ({ label: ig, value: ig })) ?? { label: 'Loading', value: 'Loading' };
    checkforNullAndSort(mappedInvoiceGroup);
    const filteredProfitCenters = iPData.profitCenters.filter((pc: ProfitCenterType) => pc.DateDeactivated === null);
    const mappedProfitCenters = filteredProfitCenters.map((pc: ProfitCenterType) => ({ label: pc.ProfitCenterName, value: pc.ProfitCenterID })) ?? { label: 'Loading', value: 'Loading' };
    checkforNullAndSort(mappedProfitCenters)
    weekEnd = weekEndingArray.map((day, idx) => ({ label: day, value: idx }));

    // ***************************** updating invoice progress items and making array of items to change in progress
    const handleIPEdit = (e: any, iPItem: EditableInvoiceType) => {
        let editableInvoiceCopy = invoices;
        if (e.target.name === "DateSent") {
            let editedInvoice = { ...iPItem, Dirty: true }
            editableInvoiceCopy = editableInvoiceCopy.map(x => {
                if(x.Index === iPItem.Index){
                    return editedInvoice
                }
                else{
                    return x
                }
            })
            setInvoices([...editableInvoiceCopy]);
            handleDateSentEdit(e, iPItem)
        } 
        else if(e.target.name ==="InvoiceAmount" || e.target.name === "MiscAmount" || e.target.name === "BillableTickets"){

            let thisInvoice = invoices.find(x => x.Index === iPItem.Index)
            var val = e.target.value.split(",").join("")
            var num = val.split(".")
            var index = e.target.selectionStart
            if(num[0].length>6 && e.target.name !== "BillableTickets"){
                return
            }
            if(num.length>1 && e.target.name !== "BillableTickets"){
                if(num[1].length>2){
                    return
                }
            }
            if(num.length>2){
                val = num[0] + num[1]
            }
            if(e.target.name === "BillableTickets"){
                val = val.replace('.','')
            }
            thisInvoice = { ...thisInvoice, [e.target.name]: val.replace(/[^0-9.]/g,''), Dirty: true } as EditableInvoiceType
            editableInvoiceCopy = editableInvoiceCopy.map(x => {
                if(x.Index === iPItem.Index){
                    return thisInvoice as EditableInvoiceType
                }
                else{
                    return x
                }
            })
            setInvoices([...editableInvoiceCopy]);
            e.target.selectionStart = index
        }
        else {
            let thisInvoice = invoices.find(x => x.Index === iPItem.Index)
            thisInvoice = { ...thisInvoice, [e.target.name]: e.target.value, Dirty: true } as EditableInvoiceType
            editableInvoiceCopy = editableInvoiceCopy.map(x => {
                if(x.Index === iPItem.Index){
                    return thisInvoice as EditableInvoiceType
                }
                else{
                    return x
                }
            })
            setInvoices([...editableInvoiceCopy]);
        }
        //console.log(e.target.name, e.target.value, editableInvoiceCopy)
    }

    //TODO: A lot of logs here to get rid of if this all keeps working
    const handleDateSentEdit = (e: any, invoice: EditableInvoiceType) => {
        //console.log("DateSent and Tacos ", invoice)
        setDateWillConvert(dayjs(e.target.value).isValid() && dayjs(e.target.value).year()>2000);
        let thisDateWillConvert = dayjs(e.target.value).isValid() && dayjs(e.target.value).year()>1999
        let editableInvoiceCopy = invoices
        //console.log("Date Will Convert ", thisDateWillConvert, moment(e.target.value).utc())
        handleDateEditInProgressArray(invoice.Index, !thisDateWillConvert);
        if (true) {
            //let convertedDate = dayjs(e.target.value).format('MM/DD/YYYY 00:00:00').toString();
            //console.log(`%c LOOKING GOOD! ${dateWillConvert} ${convertedDate} ${thisDateWillConvert}`, "color: chartreuse")
            invoice = ({ ...invoice, [e.target.name]: e.target.value, Dirty: true });
            //console.log("DateSent Invoice ", invoice)
            editableInvoiceCopy = editableInvoiceCopy.map(x => {
                if(x.Index === invoice.Index){
                    return invoice
                }
                else{
                    return x
                }
            })
            //console.log("Editable Invoice Copy ", editableInvoiceCopy)
            setInvoices([...editableInvoiceCopy])
        }
    }

    const handleDateEditInProgressArray = (index: number, inProgress: boolean) => {
        let datesInProgressCopy = [...datesInProgress]
        let indexInArray = datesInProgressCopy.indexOf(index);
        if (inProgress) {
            if (indexInArray === -1) {
                datesInProgressCopy.push(index);
            }
        } else {
            if (datesInProgressCopy[0] === index) { //splice would not work with first item in array.
                datesInProgressCopy.shift()
            }
            if (indexInArray > -1) {
                datesInProgressCopy.splice(indexInArray, 1)
            }
        }
        setDatesInProgress(datesInProgressCopy);
    }

    const handleIsPaidSelect = (name: string, invoiceItem: EditableInvoiceType) => {
        let editableInvoiceCopy = invoices;
        if(name !== "IsPaid"){
            return
        }
        let thisInvoice = invoices.find(x => x.Index === invoiceItem.Index)
        thisInvoice = { ...thisInvoice, IsPaid: !invoiceItem.IsPaid, Dirty: true } as EditableInvoiceType
        editableInvoiceCopy = editableInvoiceCopy.map(x => {
            if(x.Index === invoiceItem.Index){
                return thisInvoice as EditableInvoiceType
            }
            else{
                return x
            }
        })
        setInvoices([...editableInvoiceCopy]);
    }

    // const handleSaveInvoiceProgress = () => {
    //     setSaving(true);
    //     for (let i = 0; i < invoices.length; i++) {
    //         let entryToUpdate = { ...invoices[i] };
    //         if (entryToUpdate.Dirty) {
    //             //console.log("Item Updating ", entryToUpdate);
    //             saveEditedInvoiceProgress(entryToUpdate, entryToUpdate.Index)
    //         }
    //     }
    //     getInvoicesByIGorPC()
    // }

    const handleSaveInvoiceProgress = (index:number) => {
        if(datesInProgress.some((indexOfItem) => index === indexOfItem)){
            alert("Invalid date please try again.")
            return
        }
        setSaving(true)
        let saveIndex = savingIndex
        saveIndex.push(index) 
        setSavingIndex([...saveIndex])
        let entryToUpdate: InvoiceType = {
            ...invoices[index], 
            BillableTickets: invoices[index].BillableTickets.toString() === ""? 0:Number(invoices[index].BillableTickets), 
            InvoiceAmount: invoices[index].InvoiceAmount?.toString() === ""? 0:Number(invoices[index].InvoiceAmount),
            MiscAmount: invoices[index].MiscAmount?.toString() === ""? 0:Number(invoices[index].MiscAmount)
        }
        if(invoices[index].FromIP === false){
            saveNewEditedInvoiceProgress(entryToUpdate, index)
        }
        else{
            saveEditedInvoiceProgress(entryToUpdate, index)
        }
    }

    const saveNewEditedInvoiceProgress = (invoice: InvoiceType, entryIndex: number) =>{
        var billingGroup = billingGroups.find(x => x.BillingGroupID === invoice.BillingGroupID)
        Axios.post(`${process.env.REACT_APP_API_URL}/api/ip/SaveNewInvoiceProgress`, {
            ...invoice, 
            isXlsx: billingGroup?.isXLSX ?? false, 
            isPDF: billingGroup?.isPDF ?? false, 
            InvoiceStoreLocation: billingGroup?.InvoiceStorageLocation,
            EmployeeID: props.userid
        }, config)
        .then((res) => {
            let saveIndex = savingIndex
            saveIndex = saveIndex.filter(x => x !== entryIndex)
            setSavingIndex([...saveIndex])
            setSaving(false)
            if(!res.data.error.success){
                alert(
                    res.data.error.message 
                )
                return;
            }
            if(res.data.error.message!=null){
                alert(
                    res.data.error.message 
                )
            }
            getInvoicesByIGorPC(invoice.InvoiceProgressID);
        })
        .catch((err) => {
            let saveIndex = savingIndex
            saveIndex = saveIndex.filter(x => x !== entryIndex)
            setSavingIndex([...saveIndex])
            setSaving(false)
        })
    }

    const saveEditedInvoiceProgress = (entryToSave: InvoiceType, entriesIndex: number) => {
        Axios.post(`${process.env.REACT_APP_API_URL}/api/ip/addOrUpdateInvoiceProgress`, entryToSave, config)
            .then((res) => {
                //console.log("LOOK")
                //console.log("LOOK", res.data);
                //handleInvoiceArrayUpdate(makeItemEditable(res.data, entriesIndex), entriesIndex);
                let saveIndex = savingIndex
                saveIndex = saveIndex.filter(x => x !== entriesIndex)
                setSavingIndex([...saveIndex])
                setSaving(false)
                getInvoicesByIGorPC(entryToSave.InvoiceProgressID);
            })
            .catch((err) => {
                let saveIndex = savingIndex
                saveIndex = saveIndex.filter(x => x !== entriesIndex)
                setSavingIndex([...saveIndex])
                setSaving(false)
                alert(err)
                //console.log(`%c Error in getting billing groups: ${err}`, "color: red; font-size:14px; font-weight: bold");
            })
    }

    // const handleInvoiceArrayUpdate = (ipItemToUpdate: EditableInvoiceType, itemIndex: number) => {
    //     let invoiceArrayCopy: EditableInvoiceType[] = [...invoices]
    //     invoiceArrayCopy[itemIndex] = { ...ipItemToUpdate }
    //     setInvoices(invoiceArrayCopy);
    // }

    useEffect(() => {
        //?? set api/ip/getbillinggroups/true to get inactives or false to not get inactives
        Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getbillinggroups/true`, config)
            .then((res) => {
                setBillingGroups([...res.data])
                setBillingGroupsLoaded(true);
            })
            .catch((err) => {
                //console.log(`%c Error in getting billing groups: ${err}`, "color: red; font-size:14px; font-weight: bold");
            })
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [showEditBillingGroup])

    // ******************************************* File Uploader stuff  **************

    const handleShowUploader = () => {
        setShowUploader(!showUploader)
        let elem = document.getElementById("InvoiceProgress")
        //logic is backwards because its waiting for a state update (ben kile)
        if (showUploader && elem) {
            // elem.style.opacity = "1"
            elem.style.display = "block"
        } else if (elem) {
            // elem.style.opacity = ".6"
            elem.style.display = "none"
        }
    }

    const sendFileLocationToApi = (relativePath: string) => {
        setRelativePathString(relativePath);
        //console.log("sendFileLocationToApi", relativePath)
    }

    const handleOpenInvoiceModal = () => {
        setShowInvoice(!showInvoice)
    }
    const handleFocus = (InvoiceNumber: string, profitCenter:string, field: string) =>{
        var id = `${InvoiceNumber},${profitCenter}:${field}`
        setInputFocus(id)
    }

    const handleShowEmailPreviewModal = () => {
        setShowEmailPreview(!showEmailPreview)
    }

    //TODO: See if timeout helped with the send invoice not working after first one!
    const formatNumberInput = (num:string, displayCurrency:boolean, displayCommas: boolean) => {
        var number = num.split('.')
        var whole = number[0]
        var ret = []
        if(displayCommas){
            for(var i = 0; i<whole.length; i++){
                ret.push(whole[i])
                if((whole.length-i)%3===1 && (i+1)<whole.length){
                    ret.push(",")
                }
            }
        }
        else{
            ret.push(whole)
        }
        if(number.length>1){
            ret.push('.')
            ret.push(number[1])
            if(displayCurrency && number[1].length<2){
                ret.push('0')
                if(number[1].length<1){
                    ret.push('0')
                }
            }
        }
        else if(displayCurrency){
            if(ret.length===0){
                ret.push("0")
            }
            ret.push('.00')
        }
        return ret.join("")
    }
    //console.log("INVOICES")
    //console.log(invoices.some((el) => el.Dirty === true), invoices)
    const sortColumns = (column: keyof EditableInvoiceType) => {
        var sortable: {InvoiceProgressID: number, BillingGroupName: string}[]
        if(column==="BillingGroupName" as keyof EditableInvoiceType){
            var sortable = invoices.map(x => {
                let name = billingGroups.find(y => y.BillingGroupID === x.BillingGroupID)

                return(
                    {
                        InvoiceProgressID: x.InvoiceProgressID,
                        BillingGroupName: name?.BillingGroupName ?? ""
                    }
                )
            })
        }
        var magnitude = 1
        if(sortCol===column){
            magnitude = sortDir*-1
        }
        if(invoices && column){
            var copyInvoices = invoices.sort((a,b) => {
                var x = a[column]
                var y = b[column]
                if(column==="BillingGroupName" as keyof EditableInvoiceType){
                    x = sortable.find(t => t.InvoiceProgressID===a.InvoiceProgressID)?.BillingGroupName ?? null
                    y = sortable.find(t => t.InvoiceProgressID===b.InvoiceProgressID)?.BillingGroupName ?? null
                }
                if(x !== null && y !== null){
                    if(x>y){
                        return 1*magnitude
                    }
                    else if(y>x){
                        return -1*magnitude
                    }
                    else{
                        return 0
                    }
                }
                else if(x===y){
                    return 0
                }
                else if(x===null){
                    return 1
                }
                else if(y===null){
                    return -1
                }
                else{
                    return 0
                }
            })
            setSortDir(magnitude)
            setSortCol(column)
            setInvoices([...copyInvoices])
        }
    }
    const formatDate = (date:string|Date|null) => {
        if(typeof date ==="string"){
            date = date.replace("/", "-")
            var dateSplit = date.split("T")
            if(dateSplit[1] == null){
                return dateSplit[0]
            }
            else{
                let newSplit= dateSplit[0].split("-")
                return `${newSplit[0]}-${newSplit[1]}-${newSplit[2]}`
            }
        }
        else if(date == null){
            return "--/--/----"
        }
        else{
            var dateSplit = date.toString().split("T")
            let newSplit= dateSplit[0].split("-")
            return `${newSplit[1]}-${newSplit[2]}-${newSplit[0]}`
        }
    }
    return (
        <div id="InvoiceProgress" className="main-content col-sm">
            <h2>Invoice Progress</h2>
            <div className="invoice-selection-bar d-flex flex-row mt-5 w-100">
                <div className="week-ending-div d-flex flex-row ml-4">
                    <p className="font-weight-bold selection-labels fs-4 mt-1">Week Ending</p>
                    <Select
                        className="week-ending-select ml-2 mb-2"
                        onChange={(e: any) => handleWeekEndChange(e, setWeekEndSelection)}
                        options={weekEnd}
                    />
                </div>
                <div className="invoice-group-div d-flex flex-row ml-4">
                    {
                        <p className="font-weight-bold selection-labels fs-4 mt-1 w-40">{radioSelect === 'invoiceGroup' ? "Invoice Group" : "Profit Center"}</p>
                    }
                    <Select
                        className="invoice-group-select ml-2 mb-2"
                        options={radioSelect === 'invoiceGroup' ?
                            mappedInvoiceGroup
                            :
                            mappedProfitCenters
                        }
                        onChange={(e: any) => handleInvoiceGroupOrProfitCenterChange(e, setSelectedInvoiceGOrProfitC)}
                    />
                </div>
                <div className="table-count-div ml-5">
                    <p className="font-weight-bold selection-labels fs-4 mt-2"> {`${numberOfRecords} ${numberOfRecords > 1 || numberOfRecords === 0 ? 'records' : 'record'} `} </p>
                </div>
                <div className="radio-filter-div d-flex flex-row  ml-5 mr-1 mt-2">
                    <div className="flex-row d-flex">
                        {
                            // editableInvoices.some((el) => el.Dirty === true) && (dateWillConvert === true) ?
                            invoices.some((el) => el.Dirty === true) ? // Showing save button after any item gets edited
                                // saving ? // showing saving spinner if save has been clicked
                                //     <Button className="btn btn-primary" type="button" disabled >
                                //         <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                //         Saving Invoice Progress
                                //     </Button>
                                //     : // show save button if not saving and form has been edited
                                //     <Button
                                //         onClick={handleSaveInvoiceProgress}
                                //     >
                                //         Save Invoice Progress
                                //     </Button>
                                <>
                                    <div className="radio-grouping">
                                        <input type="radio" id="invoice-group-radio" name="radio-select" value="invoiceGroup" onChange={(e: any) => handleInvoiceOrProfitCenterCheck(e, setRadioSelect)} checked={radioSelect === "invoiceGroup"} />
                                        <label className="font-weight-bold selection-labels mr-3"  >Invoice Group</label>
                                    </div>
                                    <div className="radio-grouping" >
                                        <input type="radio" id="profit-center-radio" name="radio-select" value="profitCenter" onChange={(e: any) => handleInvoiceOrProfitCenterCheck(e, setRadioSelect)} checked={radioSelect === "profitCenter"} />
                                        <label className="font-weight-bold selection-labels">Profit Center</label>
                                    </div>
                                </>
                                : // Showing the default radio buttons when nothing has been changed or is saving
                                <>
                                    <div className="radio-grouping">
                                        <input type="radio" id="invoice-group-radio" name="radio-select" value="invoiceGroup" onChange={(e: any) => handleInvoiceOrProfitCenterCheck(e, setRadioSelect)} checked={radioSelect === "invoiceGroup"} />
                                        <label className="font-weight-bold selection-labels mr-3"  >Invoice Group</label>
                                    </div>
                                    <div className="radio-grouping" >
                                        <input type="radio" id="profit-center-radio" name="radio-select" value="profitCenter" onChange={(e: any) => handleInvoiceOrProfitCenterCheck(e, setRadioSelect)} checked={radioSelect === "profitCenter"} />
                                        <label className="font-weight-bold selection-labels">Profit Center</label>
                                    </div>
                                </>
                        }
                    </div>
                </div>
                <div className="search-div ml-2">
                    {
                        billingGroupsLoaded ?
                            <SearchInput
                                id="search-input"
                                onChange={handleSearchChange}
                            /> :  //Loading spinner, because we need all billingGroups or the searches won't label them properly
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                    }
                </div>
            </div>
            <div className="table-div w-100">
                <Table
                    // onMouseLeave={() => mouseLeftTable()} 
                    responsive
                    bordered
                    className="invoice-progress-table"
                    size="sm"
                >
                    <thead>
                        <tr>
                            <th onClick={() => sortColumns("BillingGroupName" as keyof EditableInvoiceType)}>Billing Group Name</th>
                            <th onClick={() => sortColumns("ProfitCenterDesc")}>Profit Center</th>
                            <th onClick={() => sortColumns("InvoiceNumber")}>Invoice Number</th>
                            <th onClick={() => sortColumns("LastInvoiceAmount")}>
                                <div className="amountHeader text-right">
                                    <span>
                                        Last Invoice Amount
                                    </span>
                                </div>
                            </th>
                            <th onClick={() => sortColumns("InvoiceAmount")}>
                                <div className="amountHeader text-right">
                                    <span>
                                        Invoice Amount
                                    </span>
                                </div>
                            </th>
                            <th onClick={() => sortColumns("BillableTickets")}>Billable Tickets</th>
                            <th className="tax-amount-header" onClick={() => sortColumns("MiscAmount")}>
                                Tax Amount
                            </th>
                            <th className="date-sent-header" onClick={() => sortColumns("DateSent")}>
                                Date Sent
                            </th>
                            <th onClick={() => sortColumns("IsPaid")}>Is Paid</th>
                            <th onClick={() => sortColumns("DateLastModified")}>Last Modified Date</th>
                            <th onClick={() => sortColumns("UserLastModified")}>Last Modified User</th>
                            <th onClick={() => sortColumns("DateCreated")}>Created Date</th>
                            <th onClick={() => sortColumns("UserCreated")}>Created by</th>
                            <th className="flag-ip-cell" style={{background: "white", zIndex:1}}></th>
                        </tr>
                    </thead>
                    <tbody >
                        {
                            invoices?.map((item: EditableInvoiceType, idx) => {
                                // //console.log("ITEM ::::: ", item, invoices)
                                const billingGroup: BillingGroupNameType = activeBillingGroups.find((group: BillingGroupNameType) =>
                                    group.BillingGroupID === item.BillingGroupID)
                                    || { BillingGroupID: item?.BillingGroupID, BillingGroupName: item.BillingGroupID? item.BillingGroupID.toString(): "" };
                                //r-18-lint-cm
                                //eslint-disable-next-line
                                const editedInvoice = iPItemsToEdit?.find((editedIP: InvoiceType) => editedIP.InvoiceProgressID === item.InvoiceProgressID);

                                return (
                                    <tr 
                                        key={idx}  
                                        className="ip-table-row" 
                                        onContextMenu={(e: any) => handleContextMenu(e, item.Index, item.BillingGroupID, idx)}
                                    >
                                        <td>{billingGroup.BillingGroupName}</td>
                                        <td>{item.ProfitCenterDesc}</td>
                                        <td className="smaller-ip-cell">{item.InvoiceNumber} </td>
                                        <td className="amount-ip-cell text-right">${formatNumberInput(item.LastInvoiceAmount.toString()??'0.00', true, true )}</td>
                                        {shouldAllowAccess("IP") ?
                                            <>
                                                <td className="invoice-amt ip-input-cell">
                                                    <div className="d-flex flex-row ">
                                                        {
                                                            <>
                                                                <label htmlFor="invoiceAmount" className="dollar-label">$</label>
                                                                {
                                                                    item.Dirty ?
                                                                        saving && savingIndex.find((x) => x===idx)!==undefined ? // spinner if saving
                                                                            <div className="spinner-border text-info" role="status">
                                                                                <span className="sr-only">Loading...</span>
                                                                            </div>
                                                                            : // Edited value if not saving and there is one
                                                                            <Form.Control
                                                                                onChange={(e) => handleIPEdit(e, item)}
                                                                                name="InvoiceAmount"
                                                                                type="text"
                                                                                value={
                                                                                    inputFocus!==`${item.InvoiceNumber},${item.ProfitCenterDesc}:InvoiceAmount`? 
                                                                                    formatNumberInput(item.InvoiceAmount?.toString()?? "0.00", true, true)
                                                                                    : item.InvoiceAmount ?? "0.00"
                                                                                }
                                                                                className="ip-inputs text-right"
                                                                                size="sm"
                                                                                onFocus={() => handleFocus(item.InvoiceNumber, item.ProfitCenterDesc, "InvoiceAmount")}
                                                                                onBlur={() => setInputFocus("")}
                                                                                pattern="/^\d+(\.\d{1,2})?$/"
                                                                                style={!item.FromIP && !item.Dirty? {color: "#03C03C"}: {}}
                                                                            />
                                                                        : // show the items value if there isn't an edited item to display
                                                                        saving && savingIndex.find((x) => x===idx)!==undefined ? // spinner if saving
                                                                        <div className="spinner-border text-info" role="status">
                                                                            <span className="sr-only">Loading...</span>
                                                                        </div>
                                                                        :
                                                                        <Form.Control
                                                                            onChange={(e) => handleIPEdit(e, item)}
                                                                            name="InvoiceAmount"
                                                                            type="text"
                                                                            value={
                                                                                formatNumberInput(item.InvoiceAmount?.toString()?? "0.00", true, inputFocus!==`${item.InvoiceNumber},${item.ProfitCenterDesc}:InvoiceAmount`)
                                                                            }
                                                                            className="ip-inputs text-right"
                                                                            size="sm"
                                                                            onFocus={() => handleFocus(item.InvoiceNumber, item.ProfitCenterDesc, "InvoiceAmount")}
                                                                            onBlur={() => setInputFocus("")}
                                                                            pattern="/^\d+(\.\d{1,2})?$/"
                                                                            style={!item.FromIP && !item.Dirty? {color: "#03C03C"}: {}}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </td>
                                                <td className="ip-input-cell">
                                                    <div className="d-flex flex-row ip-input-divs">
                                                        {
                                                            <>
                                                                {
                                                                    saving && savingIndex.find((x) => x===idx)!==undefined ? // spinner if saving
                                                                    <div className="spinner-border text-info" role="status">
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    :
                                                                    <Form.Control
                                                                        onChange={(e) => handleIPEdit(e, item)}
                                                                        name="BillableTickets"
                                                                        type="text"
                                                                        value={
                                                                            inputFocus!==`${item.InvoiceNumber},${item.ProfitCenterDesc}:BillableTickets`? 
                                                                            formatNumberInput(item.BillableTickets?.toString()?? "0", false, true)
                                                                            : item.BillableTickets ?? "0"
                                                                        }
                                                                        className="ip-inputs text-right"
                                                                        size="sm"
                                                                        onFocus={() => handleFocus(item.InvoiceNumber, item.ProfitCenterDesc, "BillableTickets")}
                                                                        onBlur={() => setInputFocus("")}
                                                                        style={!item.FromIP && !item.Dirty? {color: "#03C03C"}: {}}
                                                                    />
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </td>
                                                <td className="ip-input-cell">
                                                    <div className="d-flex flex-row ip-input-divs">
                                                        {
                                                            <>
                                                                <label htmlFor="taxAmount" className="dollar-label">$</label>
                                                                {
                                                                    item.Dirty ?
                                                                        saving && savingIndex.find((x) => x===idx)!==undefined ? // spinner if saving
                                                                            <div className="spinner-border text-info" role="status">
                                                                                <span className="sr-only">Loading...</span>
                                                                            </div>
                                                                            : // edited value if there is one and not saving
                                                                            <Form.Control
                                                                                onChange={(e) => handleIPEdit(e, item)}
                                                                                name="MiscAmount"
                                                                                type="text"
                                                                                value={
                                                                                    inputFocus!==`${item.InvoiceNumber},${item.ProfitCenterDesc}:MiscAmount`? 
                                                                                    formatNumberInput(item.MiscAmount?.toString()?? "0", true, true)
                                                                                    : item.MiscAmount ?? "0.00"
                                                                                }
                                                                                className="ip-inputs text-right"
                                                                                size="sm"
                                                                                onFocus={() => handleFocus(item.InvoiceNumber, item.ProfitCenterDesc, "MiscAmount")}
                                                                                onBlur={() => setInputFocus("")}
                                                                                style={!item.FromIP && !item.Dirty? {color: "#03C03C"}: {}}
                                                                            />
                                                                        : // show the items value if there isn't an edited item to display
                                                                        saving && savingIndex.find((x) => x===idx)!==undefined ? // spinner if saving
                                                                        <div className="spinner-border text-info" role="status">
                                                                            <span className="sr-only">Loading...</span>
                                                                        </div>
                                                                        :
                                                                        <Form.Control
                                                                            onChange={(e) => handleIPEdit(e, item)}
                                                                            name="MiscAmount"
                                                                            type="text"
                                                                            value={
                                                                                formatNumberInput(item.MiscAmount?.toString()?? "0", true, inputFocus!==`${item.InvoiceNumber},${item.ProfitCenterDesc}:MiscAmount`)
                                                                            }
                                                                            className="ip-inputs text-right"
                                                                            size="sm"
                                                                            onFocus={() => handleFocus(item.InvoiceNumber, item.ProfitCenterDesc, "MiscAmount")}
                                                                            onBlur={() => setInputFocus("")}
                                                                            style={!item.FromIP && !item.Dirty? {color: "#03C03C"}: {}}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </td>
                                            </>
                                            :
                                            <>
                                                <td>
                                                    <div className="d-flex flex-row">
                                                        {item.InvoiceAmount}
                                                    </div>
                                                </td>
                                                <td>{item.BillableTickets}</td>
                                                <td>
                                                    <div className="d-flex flex-row">
                                                        {item.MiscAmount}
                                                    </div>
                                                </td>
                                            </>
                                        }
                                        {
                                            shouldAllowAccess("IP:ADMIN") ?
                                                (
                                                <td>
                                                    <div className="DateSentText">
                                                        <Form.Control
                                                            type="date"
                                                            value={formatDate(item.DateSent)}
                                                            onChange={(e) => handleIPEdit(e, item)}
                                                            name="DateSent"
                                                            size="sm"
                                                        />
                                                    </div>
                                                    {
                                                        // not valid date and it's included in the edited items then show this
                                                        (datesInProgress.some((indexOfItem) => item.Index === indexOfItem)) &&
                                                        <p className={`date-incorrect date-${item.Index}`}>Incorrect Date Format</p>
                                                    }
                                                </td>)
                                                : //Below is not allowed to edit
                                                <td className="smaller-ip-cell">{dayjs(item.DateSent).isValid() ? dayjs(item.DateSent).format('MM-DD-YYYY'):""}</td>
                                        }
                                        {/* <td className="smaller-ip-cell">{moment(item.DateSent).format('MM-DD-YYYY')}</td> */}
                                        {
                                            shouldAllowAccess("IP:ADMIN") ?
                                                
                                                <td className="smallest-ip-cell" >
                                                    <Checkbox id="is-paid-checkbox" isChecked={item.IsPaid} name="IsPaid" onChange={(e: string) => handleIsPaidSelect(e, item)}/>
                                                </td>
                                                
                                                : //Below is not allowed to edit
                                                <td className="smallest-ip-cell"  style={{"pointerEvents": "none"}}>
                                                    <Checkbox id="is-paid-checkbox" isChecked={item.IsPaid} name="IsPaid" onChange={null} isDisabled={true}/>
                                                </td>
                                        }
                                        <td className="smaller-ip-cell">{dayjs(item.DateLastModified).format('MM-DD-YYYY')}</td>
                                        <td className="ip-user-cells">{item.UserLastModified}</td>
                                        <td className="smaller-ip-cell">{dayjs(item.DateCreated).format('MM-DD-YYYY')}</td>
                                        <td className="ip-user-cells">{item.UserCreated}</td>
                                        <td className="flag-ip-cell">
                                        {
                                             saving && savingIndex.find((x) => x===idx)!==undefined ? // spinner if saving
                                             <div className="spinner-border text-info" role="status">
                                                 <span className="sr-only">Loading...</span>
                                             </div>
                                             :
                                            <span 
                                             className="material-icons" 
                                             style={item.Dirty || !item.FromIP? {color: "#007bff"}: {color: "#C0C0C0"}}
                                             onClick={() => item.Dirty || !item.FromIP? handleSaveInvoiceProgress(idx): null}
                                            >
                                                save
                                            </span>
                                        }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </div>
            {/* <Button className="mt-4" onClick={() => handleShowPastDueSummary()} >Show Past Due Summary</Button> */}
            {/*//**************************** Page Modal section ****************************************** */}
            {
                <Modal show={showEditBillingGroup} id="edit-billing-group-modal" dialogClassName="edit-billing-group-modal-class">
                    <EditBillingGroup
                        showEditBillingGroup={showEditBillingGroup}
                        setShowEditBillingGroup={setShowEditBillingGroup}
                        billingGroup={currentBillingGroup}
                        invoices={invoices}
                        setInvoices={setInvoices}
                        contactDetailsOnly={contactDetailsOnly}
                        getActiveBillingGroups={getActiveBillingGroups}
                        setActiveBillingGroups={setActiveBillingGroups}
                        activeBillingGroups={activeBillingGroups}
                        setContactDetailsOnly={setContactDetailsOnly}
                    />
                </Modal>
            }
            {
                <Modal show={showSearchResults} id="search-results-modal">
                    <InvoiceSearch
                        setShowSearchResults={setShowSearchResults}
                        invoicesFromSearch={invoicesFromSearch}
                        invoicePaymentsFromSearch={invoicePaymentsFromSearch}
                        currentInvoice={currentInvoice}
                        setCurrentInvoice={setCurrentInvoice}
                        profitCenters={iPData.profitCenters}
                        billingGroups={billingGroups}
                        selectInvoiceFromSearch={selectInvoiceFromSearch}
                    />
                </Modal>
            }
            {
                <Modal show={showEmailPreview} id="Invoice-Email-Preview-Modal"  >
                    <InvoiceEmailPreview
                        setShowEmailPreview={setShowEmailPreview}
                        currentBillingGroup={currentBillingGroup}
                        currentInvoice={currentInvoice}
                        setCurrentBillingGroup={setCurrentBillingGroup}
                        billingGroups={activeBillingGroups}
                        setShowEditBillingGroup={setShowEditBillingGroup}
                        extension={fileExtension}
                        getInvoicesByIGorPC={getInvoicesByIGorPC}
                        invoiceIndex={currIndex}
                        saveInvoice={saveEditedInvoiceProgress}
                        employeeID={props.userid}
                    />
                </Modal>
            }
            {
                showPastDueAlert &&
                <Alert variant='primary'>
                    {alertText}
                </Alert>
            }
            {
                <Modal show={resendModal}>
                    <Modal.Header>
                        <h5>Resend Invoice</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <span>Are you sure you want to resend this invoice? Resending the invoice will not change the date sent value.</span>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={() => setResendModal(false)}>Cancel</Button>
                        <Button onClick={() => (setResendModal(false), handleShowEmailPreviewModal())}>Continue</Button>
                    </Modal.Footer>
                </Modal>
            }
            {/* {showUploader &&
                <InvoiceUploader
                    toggleInvoiceUploader={handleShowUploader}
                    //@ts-ignore
                    sendFileLocationToApi={sendFileLocationToApi}
                    setAttachmentName={null}
                    //@ts-ignore
                    directory={currentBillingGroup.InvoiceStorageLocation}
                    invoice={currentInvoice}
                    invoiceProgressID={currentInvoice.InvoiceProgressID}
                    //@ts-ignore
                    storageLocation={storageLocation}//different in prod
                    //@ts-ignore
                    containerName={containerName}//different in prod
                    //@ts-ignore
                    fileStoreLocationId={fileStoreLocationId}//different in prod
                    setAttachmentID={setAttachmentID}
                    getInvoicesByIGorPC={getInvoicesByIGorPC}
                />
            } */}
            {/*//*******************************  Context Menu *************************************************   */}
            {
                showInvoice &&
                <DocViewer
                    fileName={currentInvoice.InvoiceNumber}
                    extension={fileExtension}
                    invoice={currentInvoice}
                    setShowInvoice={setShowInvoice}
                    showInvoice={showInvoice}
                    attachmentRecords={attachmentRecords}
                    employeeID={props.userid}
                    billingGroup={currentBillingGroup}
                />
            }
            {
                // Only show context menu once billingGroups are loaded so that you can't break it by trying to send an email without a billing group
                (showContextMenu && activeBillingGroupsLoaded) && (
                    <ul
                        onMouseLeave={() => setShowContextMenu(!showContextMenu)}
                        className="contextMenu"
                        style={{
                            top: window.innerHeight-300>anchorPoint.y? anchorPoint.y: window.innerHeight-300,
                            left: window.innerWidth-550>anchorPoint.x? anchorPoint.x: window.innerWidth-550
                        }}
                    >
                        {
                            currentInvoice.AttachmentId !== 0 ?
                                <li
                                    // disabled={currentInvoice}
                                    className="context-menu-item"
                                    onClick={() => handleOpenInvoiceModal()}
                                >
                                    View Invoice
                                </li>
                                :
                                <li
                                    className="disabled-context-items"
                                >
                                    View Invoice
                                </li>
                        }

                        <li className="context-menu-item" onClick={handleShowContactClick} >Show Contact/Mailing Details</li>
                        {/* <li onClick={() => handleShowUploader()} className="context-menu-item">Attach Invoice</li> */}
                        <hr className="divider" />
                        {/* //TODONE: access control these two */}
                        {shouldAllowAccess("IP:ADMIN") && !dirtyCurrentInvoice?
                            (
                                <>
                                    <li className="context-menu-item"
                                        onClick={() => setShowEditBillingGroup(true)}
                                    >
                                        Edit Billing Group
                                    </li>
                                    <li
                                        onClick={() => currentInvoice.DateSent===null? handleShowEmailPreviewModal(): setResendModal(true)}
                                        className="context-menu-item">
                                        Send Invoice
                                    </li>
                                </>
                            )
                            :
                            shouldAllowAccess("IP:ADMIN")?
                                <>
                                    <li className="context-menu-item"
                                        onClick={() => setShowEditBillingGroup(true)}
                                    >
                                        Edit Billing Group
                                    </li>
                                    <li
                                        className="disabled-context-items">
                                        Send Invoice
                                    </li>
                                </>
                            :
                            (
                                <>
                                    <li className="disabled-context-items">
                                        Edit Billing Group
                                    </li>
                                    <li className="disabled-context-items" >
                                        Send Invoice
                                    </li>
                                </>
                            )
                        }
                    </ul>
                )
            }
            <Prompt
                when={invoices.some(x => (x.Dirty) || (!x.FromIP && !x.Dirty))}
                message={
                    invoices.some(x =>(!x.FromIP && !x.Dirty))? 
                    'There are unsaved prepopulated rows in the table, are you sure you want to leave?' :
                    'You have unsaved changes, are you sure you want to leave?'
                }
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    username: state.user.userName,
    userid: state.user.userId
})

export default connect(mapStateToProps)(Invoice)